import { useRef } from "react";

const Burger = () => {
    const burgerRef = useRef();

    const handleToggle = () => {
        burgerRef.current.classList.toggle("active");
        const sideBars = document.querySelector(".side");
        sideBars?.classList.toggle("active");


        // stop body from scrolling on second breakpoint(i.e. mobile and tablet devices)
        if (window.matchMedia("(max-width: 1024px)").matches) {
            const body = document.querySelector("body");
            if (sideBars?.classList.contains("active")) {
                body.style.overflow = "hidden";
            } else {
                body.style.overflow = "";
            }
        }
    };

    return (
        <div ref={burgerRef} className="burger" onClick={handleToggle}>
            <div className="line line1"></div>
            <div className="line line2"></div>
            <div className="line line3"></div>
        </div>
    );
};

export default Burger;
